
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 2.81C7.508-1.606 0-.95 0 5.73 0 9.058 2.295 13.487 9 18c6.705-4.513 9-8.942 9-12.27 0-6.642-7.5-7.363-9-2.92z","fill":"#FFF"}})])
          )
        }
      }
    